const HTML = {
  summaryMain: document.querySelector("#summary #list ul"),
  summaryStats: document.querySelector("#summary #stats > ul"),
  // summaryYearData: document.querySelector("#year .data"),
  summaryCategories: document.querySelector("#summary #categoryBar ul"),
  graph: document.getElementById("graph-entries"),
  graphDate: document.getElementById("graph-date"),
  graphTags: document.querySelectorAll("#graph-entries .entry-start"),
  graphMood: document.getElementById("graph-mood"),
  graphTimeBar: document.querySelector("#graph-timebar ul"),
  graphContainer: document.getElementById("graph-container"),
  CSS: "",
};

const CSS = {
  summaryEntryWidth: getComputedStyle(document.body).getPropertyValue('--summaryEntryWidth'),
  mood: {
    1: getComputedStyle(document.body).getPropertyValue('--mood1'),
    2: getComputedStyle(document.body).getPropertyValue('--mood2'),
    3: getComputedStyle(document.body).getPropertyValue('--mood3'),
    4: getComputedStyle(document.body).getPropertyValue('--mood4'),
    5: getComputedStyle(document.body).getPropertyValue('--mood5'),
    6: getComputedStyle(document.body).getPropertyValue('--mood6'),
    7: getComputedStyle(document.body).getPropertyValue('--mood7'),
    8: getComputedStyle(document.body).getPropertyValue('--mood8'),
    9: getComputedStyle(document.body).getPropertyValue('--mood9'),
  },
  graphHourHeight: getComputedStyle(document.body).getPropertyValue('--graphHourHeight'),
  graphContainerWidth: String(getComputedStyle(document.body).getPropertyValue('--graphContainerWidth').match(/\d{1,4}/)), // remove the px
  entryBorderWidth: getComputedStyle(document.body).getPropertyValue('--entry-border-width'),
};

// Functions
(function setCSS() {
  document.querySelector(':root').style.setProperty('--entry-duration', 'block')
  document.querySelector(':root').style.setProperty('--tag-label', 'block')
  document.querySelector(':root').style.setProperty('--entry-comment', 'block')
  document.querySelector(':root').style.setProperty('--entry-start', 'block')
})();

(function getCSS() {
  let list = document.styleSheets;
  for (let x = 0; x < list.length; x++) { if (list[x].title == "inline") { HTML.CSS = list[x] } }
})();

window.HTML = HTML;
window.CSS = CSS;
